import { render, staticRenderFns } from "./Parentshop.vue?vue&type=template&id=354aa2a8&"
import script from "./Parentshop.vue?vue&type=script&lang=js&"
export * from "./Parentshop.vue?vue&type=script&lang=js&"
import style0 from "./Parentshop.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports